/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="115.14"
        height="59.49"
        viewBox="0 0 115.14 59.49"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M21.85.18A1.25 1.25 0 0 1 22 2.67H1.25a1.252 1.252 0 0 1-.13-2.5h20.73ZM17.88 12.09A1.256 1.256 0 0 1 18 14.6H1.25a1.257 1.257 0 0 1-.13-2.51h16.76ZM13.33 23.85a1.25 1.25 0 0 1 .13 2.49H1.25a1.25 1.25 0 0 1-.13-2.49h12.21ZM7.29 35.5a1.25 1.25 0 0 1 .13 2.49H1.25a1.252 1.252 0 0 1-.13-2.5h6.17Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M110.69 0H34.93a4.45 4.45 0 0 0-4.41 3.85l-7 50.58A4.45 4.45 0 0 0 28 59.49h75.76a4.46 4.46 0 0 0 4.41-3.85l7-50.58A4.46 4.46 0 0 0 110.69 0ZM34.93 2.5h75.76a2 2 0 0 1 1.93 2.22l-7 50.58a2 2 0 0 1-1.93 1.69H28a2 2 0 0 1-2-2.22l7-50.58a1.94 1.94 0 0 1 1.93-1.69Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="m33 .36 34.55 33.53 44.71-32.65 1.47 2-45.55 33.29a1.26 1.26 0 0 1-1.51 0l-.1-.09-35.3-34.29Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M74.89 29.71 105.82 56l-1.62 1.91-30.93-26.29 1.62-1.91zM62.37 29.32l1.46 2.04-37.02 26.61-1.46-2.03 37.02-26.62z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'EnvelopeMovingIcon';

export default Icon;
